import { render, staticRenderFns } from "./Item7Detail2.vue?vue&type=template&id=1bf38e7d"
import script from "./Item7Detail2.vue?vue&type=script&lang=js"
export * from "./Item7Detail2.vue?vue&type=script&lang=js"
import style0 from "./Item7Detail2.vue?vue&type=style&index=0&id=1bf38e7d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports